// GENERATED FILE, DO NOT MANUALLY EDIT
import { html } from '@horizon/base';
import { HznIconBase } from '../../icon/icon-base.js';
import './types.js';
/**
 *
 * @tag hzn-icon-sort-ascending
 * @tagname hzn-icon-sort-ascending
 * @summary An individual icon for Horizon
 */
export class HznIconSortAscending extends HznIconBase {
    render() {
        return html `<div class="hzn-icon" aria-hidden="true"><svg viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.54027 5.52974L5 3.98948L5 18.3288H3L3 3.94396L1.41421 5.52974L0 4.11553L3.27013 0.845396C3.66066 0.454872 4.29382 0.454872 4.68435 0.845396L7.95448 4.11553L6.54027 5.52974ZM18 16.3288H8V14.3288H18V16.3288ZM8 12.3288H15V10.3288H8V12.3288ZM12 8.32877H8V6.32877H12V8.32877Z" fill="currentColor"></path>
</svg></div>`;
    }
}
//# sourceMappingURL=sort-ascending.js.map